export enum ApplicationStage {
  Applied = 1,
  Screened = 2,
  Candidate = 3,
  Hired = 4,
  Rejected = 5,
}

export function getApplicationStageLabel(stage: ApplicationStage): string {
  switch (stage) {
    case ApplicationStage.Applied:
      return "Applied";
    case ApplicationStage.Screened:
      return "Screened";
    case ApplicationStage.Candidate:
      return "Candidate";
    case ApplicationStage.Hired:
      return "Hired";
    case ApplicationStage.Rejected:
      return "Rejected";
    default:
      return "Unknown";
  }
}

export function getApplicationStageDescription(stage: ApplicationStage): string {
  switch (stage) {
    case ApplicationStage.Applied:
      return "The candidate has applied and is awaiting review. No screening has happened yet.";
    case ApplicationStage.Screened:
      return "An initial review has been done. This stage is set manually by your team — there's no automatic trigger that moves an application here.";
    case ApplicationStage.Candidate:
      return "Progressed past initial screening. Like other pipeline stages, this is set manually by your team, not automatically.";
    case ApplicationStage.Hired:
      return "The candidate has been hired.";
    case ApplicationStage.Rejected:
      return "The candidate has been rejected and notified by email.";
    default:
      return "Current stage of this application in the recruitment pipeline.";
  }
}

export function getApplicationStageBadgeVariant(
  stage: ApplicationStage,
): "default" | "secondary" | "destructive" | "outline"|"success" {
  switch (stage) {
    case ApplicationStage.Applied:
      return "secondary";
    case ApplicationStage.Screened:
      return "outline";
    case ApplicationStage.Candidate:
      return "default";
    case ApplicationStage.Hired:
      return "success";
    case ApplicationStage.Rejected:
      return "destructive";
    default:
      return "secondary";
  }
}
